import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { CustomRouteReuseStrategy } from 'src/app/custom-route-reuse.strategy';
import { ShopAndShipPageComponent } from '../pages/shop-and-ship-page/shop-and-ship-page.component.';
import { ShopAndShipToCountryPageComponent } from '../pages/to-country-page/to-country-page.component.';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'australia',
    pathMatch: 'full'
  },
  {
    path: ':toCountryName', 
    component: ShopAndShipToCountryPageComponent,
  },
  {
    path: ':fromCountryName/:toCountryName',
    component: ShopAndShipPageComponent,
  },
  
  
];

@NgModule({
  imports: [RouterModule.forChild(routes,)],
  exports: [RouterModule],
  providers: [{ provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }]
})
export class ShopAndShipRoutingModule {}
